const galleryId = 13;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": {"en": ""},
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}

let group = [];

group = ["sh_1829640692.jpg","sh_1829640689.jpg","sh_1741122284.jpg","sh_1741122287.jpg","sh_1741122281.jpg","sh_1741122278.jpg","sh_1741122275.jpg","sh_1741122269.jpg"];
group.forEach((i) => addItemToGroup(i, '01. Bone graft - Using a block of bone'));

group = ["sh_1741122317.jpg","sh_1741122311.jpg","sh_1741122308.jpg","sh_1741122305.jpg","sh_1741122296.jpg","sh_1741122302.jpg","sh_1741122299.jpg"];
group.forEach((i) => addItemToGroup(i, '02. Bone graft - ring method'));

group = ["sh_1386883037.jpg","sh_1386883034.jpg","sh_1431704591.jpg","sh_1611519880.jpg","sh_1611519883.jpg","sh_1611519889.jpg","sh_1611519874.jpg","sh_1386883037b.jpg","sh_1386883037c.jpg","sh_1386883037d.jpg","sh_1405987181.jpg","sh_1444882256.jpg"];
group.forEach((i) => addItemToGroup(i, '03. Augmentation Surgery'));

group = ["sh_1710200125.jpg","sh_1710200128.jpg","sh_1710200131.jpg","sh_1710200119.jpg","sh_1710200116.jpg","sh_1710200110.jpg","sh_1710200113.jpg"];
group.forEach((i) => addItemToGroup(i, '04. Bone splitting'));

group = ["sh_1582203985.jpg","sh_1582203976.jpg","sh_1727881036.jpg"];
group.forEach((i) => addItemToGroup(i, '05. Bone transplantation'));

group = ["sh_278526386.jpg","sh_435497371.jpg","sh_466103261.jpg","sh_1058934656.jpg","sh_631062824.jpg","sh_1192014592.jpg","sh_758006686.jpg"];
group.forEach((i) => addItemToGroup(i, '06. Surgery #1'));

group = ["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","8.jpg","9.jpg","11.jpg","10.jpg","12.jpg","13.jpg"];
group.forEach((i) => addItemToGroup(i, '07. Surgery #2'));

group = ["sh_1426671056.jpg","sh_250863907.jpg","sh_250863955.jpg","sh_257973077.jpg","sh_257973089.jpg","sh_257973059.jpg","sh_250863940.jpg","sh_250863919.jpg","sh_1426671041.jpg"];
group.forEach((i) => addItemToGroup(i, '08. Surgery #3'));

group = ["sh_1417027889.jpg","sh_1387980332.jpg"];
group.forEach((i) => addItemToGroup(i, '09. Surgery #4'));

group = ["sh_1229172997.jpg","sh_1256946904.jpg","sh_1229172916.jpg","sh_1229172934.jpg","sh_1229172910.jpg","sh_1229172919.jpg"];
group.forEach((i) => addItemToGroup(i, '10. Surgery #5 (full lower)'));

group = ["sh_1229172970.jpg","sh_1220199376.jpg","sh_1229172976.jpg","sh_1229172928.jpg","sh_1229172994.jpg","sh_1424866211.jpg","sh_1218120160.jpg","sh_1218120214.jpg","sh_1257114304.jpg","sh_1257114310.jpg","sh_1229172925.jpg","sh_1257114322.jpg"];
group.forEach((i) => addItemToGroup(i, '11. Surgery #6 (full upper)'));

group = ["sh_1611519886.jpg","sh_1431704588.jpg","sh_1386883040.jpg","sh_1431704594.jpg","sh_1829640701.jpg","sh_1710200308.jpg","sh_1710200305.jpg","sh_1741122293.jpg","sh_1741122290.jpg","7.jpg","sh_1218120169.jpg","sh_1229173144.jpg","sh_1257123682.jpg","sh_1257123673.jpg", "sh_1810254385.jpg","sh_1524366176.jpg","sh_1627811560.jpg","sh_1829640683.jpg","sh_1829640668.jpg","sh_1829640680.jpg","sh_1727881021.jpg","sh_1505970329.jpg","sh_736856104.jpg","sh_1431586433.jpg","sh_1641226969.jpg","sh_1229173135.jpg","sh_1229173060.jpg","sh_1229173051.jpg","sh_1229173030.jpg","sh_1426671191.jpg","sh_1426670972.jpg","sh_1220199313.jpg","sh_1220199364.jpg","sh_1229173153.jpg","sh_1229173147.jpg","sh_1257123556.jpg","sh_1257114274.jpg","sh_1257114271.jpg"]
group.forEach((i) => addItemToGroup(i, 'deleted'));

export default items;
